import {
  CONSIGNMENT,
  EMA,
  INSPECTED,
  MISTAKE_SHIPMENT,
  OVERHAULED,
  REPAIRED,
  TAG_DATE_CONDITIONS
} from "MODULES/Receiving/constants";
import { LOT_LINE_ITEM } from "MODULES/Lots/constants";

export function requireTagDate(condition, receivingType) {
  return (
    (TAG_DATE_CONDITIONS.includes(condition) &&
      ![CONSIGNMENT, EMA, MISTAKE_SHIPMENT].includes(receivingType)) ||
    ([CONSIGNMENT, EMA].includes(receivingType) &&
      [OVERHAULED, REPAIRED, INSPECTED].includes(condition))
  );
}

export function requireTaggedBy(condition, receivingType) {
  return (
    [CONSIGNMENT, EMA, LOT_LINE_ITEM].includes(receivingType) &&
    [OVERHAULED, REPAIRED, INSPECTED].includes(condition)
  );
}



// WEBPACK FOOTER //
// ./app/modules/Receiving/Dashboard/Create/helpers.js